<template>
 <div id="hotList">
 	<div class="hot_content" v-for="item in hotList" :key="item.id">
	 	 <dl class="hotList" @click="specialHotBuy(item.id,item.url,item.proType[0])">
	 	 	<dt><img :src="urlPrefixImg+'/'+item.topImg"/></dt>
	 	 	<dd>{{item.cateName}}</dd>
	 	 </dl>
	 </div>
 </div>
</template>

<script>
	export default{
		 props:['hotList'],
		 data(){
		return{
			urlPrefixImg:this.URL_PREFIX_IMG,
		 }
	    },
		 created:function(){
		 	
	     },
		 methods: {
	      specialHotBuy(tids,urls,type){
	    		localStorage.setItem("tid",tids);
	    		localStorage.removeItem("faceId");
	    	    localStorage.removeItem("ttype");
    		  if(urls!=""){
    	  	     this.path=urls;
    	  	     location.href=urls;
	    	  }else if(type==0){
	    	  	 localStorage.setItem("ttype",type);
	    	  	 this.$router.push({path: "/Reallygood"});//实物
	    	  }else{
	    	  	 localStorage.setItem("ttype",type);
	    	  	 this.$router.push({path: "/Cami"});
	    	  }
	      }
	    }
	}
</script>

<style scoped="scoped">
#hotList{border-bottom:1px solid #eee;}
.hot_content{width: 100%;border-top:1px solid #eee;padding: 12px 0 4px 0;display: inline-block;}
.hotList{width: 90%;margin: 0 auto;}
.hotList dt{width: 100%;overflow: hidden;}
.hotList dt img{width: 100%;}
.hotList dd{text-align: center;font-size:1.0rem; line-height:30px;color: #333;}
</style>


// WEBPACK FOOTER //
// src/components/hotList.vue